import { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

const EmailContactForm = () => {
  const form = useRef();
  const [sent, setSent] = useState('');
  const [btnTxt, setBtnTxt] = useState('Submit');

  const sendEmail = async (e) => {
    e.preventDefault();
    setBtnTxt('Sending...');

    const templateData = {
      name_first: form.current.name_first.value,
      name_last: form.current.name_last.value,
      email_address: form.current.email_address.value,
      contact_number: form.current.contact_number.value,
      message_text: form.current.message_text.value,
      reply_to: form.current.email_address.value,
      website: window.location.hostname
    };

    await emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SVC,
        process.env.REACT_APP_EMAILJS_TMP,
        templateData,
        process.env.REACT_APP_EMAILJS_KEY
      )
      .then(
        (result) => {
          setSent(JSON.stringify(result));
          // alert('Registration Successful!'); //* using button "status" !!
          setBtnTxt('Sent');
        },
        (error) => {
          console.log(error);
          setSent(JSON.stringify(error));
          setBtnTxt('Submit');
          alert('Sending NOT successful!\n- please try later -\n', sent);
        }
      );
    // setBtnTxt('Sent');
  };

  return (
    <form ref={form} id="contact1" onSubmit={sendEmail} >
      <div style={{
        display: "flex", flexWrap: "wrap",
        justifyContent: "center"
      }}>
        <div style={{ padding: "10px" }}>
          <p>
            <input
              name="name_first"
              id="name_first"
              // label="name_first"
              placeholder="First Name"
              type="text"
              required={true}
              disabled={btnTxt === 'Submit' ? false : true}
            >
            </input>
          </p>
          <p>
            <input
              name="name_last"
              id="name_last"
              // label="name_last"
              placeholder="Last Name"
              type="text"
              disabled={btnTxt === 'Submit' ? false : true}
            >
            </input>
          </p>
          <p>
            <input
              name="email_address"
              id="email_address"
              // label="email_address"
              placeholder="Email Address"
              type="email"
              required={true}
              disabled={btnTxt === 'Submit' ? false : true}
            >
            </input>
          </p>
          <p>
            <input
              name="contact_number"
              id="contact_number"
              // label="contact_number"
              placeholder="Contact Number"
              type="text"
              required={true}
              disabled={btnTxt === 'Submit' ? false : true}
            >
            </input>
          </p>
        </div>

        <div style={{ padding: "10px" }}>
          <textarea
            name="message_text"
            id="message_text"
            // label="message"
            rows="5" cols="21"
            placeholder="Type your message here"
            required={true}
            disabled={btnTxt === 'Submit' ? false : true}
          >
          </textarea>
        </div>

      </div>
      <div className='row ' style={{ display: "flex", justifyContent: "space-around" }}>

        <button
          type="submit"
          className="button buttons primary"
          default={btnTxt === 'Submit' ? true : false}
          disabled={btnTxt === 'Submit' ? false : true}
        >
          {btnTxt}
        </button>

        <button
          type="reset"
          className="button buttons secondary"
          onClick={() => setBtnTxt('Submit')} // back from "sending.." indication
        >
          Reset
        </button>

      </div>

    </form >
  );
};

export default EmailContactForm;
